import React from 'react'

import './Share.scss'
import { useAppContext } from 'context/AppContext'
import useReferralsPoints from 'hooks/useReferralsPoints'
import { fNumber, isDev } from 'helpers/common'
import Logo from 'assets/leaderboard-logo.png'

const Share: React.FC = () => {
  const { customer, pointsSettings } = useAppContext()

  const { referralsPoints, isFetching } = useReferralsPoints(
    customer?.telegram_id
  )

  const botName = isDev ? 'DevRampMeDaddyBot' : 'RampMeDaddyBot'

  const handleInviteClick = () => {
    const inviteLink = `https://t.me/${botName}?start=${customer?.referral_code}`
    navigator.clipboard.writeText(inviteLink)
    window.open(`https://t.me/share/url?url=${encodeURIComponent(inviteLink)}`)
  }

  return (
    <div className="Share">
      <header>
        <div className="Share__title">Invite friends, earn points</div>
        <img width={58} height="auto" src={Logo} alt="LeaderBoard logo" />
      </header>

      <div className="Share__title2">
        <p>
          Earn {fNumber(pointsSettings?.referral)} points for each of the first
          10 friends that start racing
        </p>
      </div>

      <section className="Share__info">
        <div className="Share__info-title">Invite a Friend!</div>

        <div className="Share__info-invite-info">
          Earn {fNumber(pointsSettings?.referral)} points for each of the first
          10 friends that start racing
        </div>

        <div className="Share__points-wrapper">
          {!isFetching && (
            <div className="Share__points">
              {fNumber(referralsPoints)} pts earned
            </div>
          )}
        </div>
      </section>

      <button className="Share__button" onClick={handleInviteClick}>
        Invite Friends
      </button>
    </div>
  )
}

export default React.memo(Share)
